<template>
  <div>
    <div class="link-warp">
      <div class="link-item active">在线充值</div>
      <Button class="goback btn-height45" to="/user/finance/account"
        >返回</Button
      >
    </div>
    <div class="section" style="position: relative">
      <loading :loading="orderLoading" style="z-index: 11"></loading>
      <div>
        账户可用金额： <span style="color: #3992e9">{{ balance }}</span> 元
      </div>
      <div class="row" style="margin:20px 0">
        <div class="name">充值金额：</div>
        <div class="label row">
          <Input
            class="height45"
            v-model="form.amount"
            placeholder="请输入充值金额"
            style="width: 200px"
            clearable
            @on-keyup="onAmountKeyUp"
          />
          <div style="margin-left: 10px">元 充值最小金额1元</div>
        </div>
      </div>
      <!-- <div class="col">
        <div class="name">充值方式</div>
        <div class="label row">
          <div
            :class="['row cz-item', { actives: active === 1 }]"
            @click="active = 1"
          >
            <img
              class="cz-icon"
              :src="require('assets/image/cz-ali-icon.png')"
            />
            <div class="text" style="color: #219fdb">支付宝</div>
          </div>
          <div
            :class="['row cz-item', { actives: active === 0 }]"
            style="margin-left: 20px"
            @click="active = 0"
          >
            <img
              class="wx-icon"
              :src="require('assets/image/cz-wechar-icon.png')"
            />
            <div class="text" style="color: #09bb07">微信</div>
          </div>
        </div>
      </div> -->
      <!-- <Button class="btn-height45" type="primary" @click="onConfirm"
        >确认充值</Button
      > -->
      <Button   class="btn-height45" disabled
        >确认充值</Button
      >
      <span style="color:#f9521f;font-size:12px;margin-left:10px">正在开发中，敬请期待！</span>
    </div>
    <!-- 支付方式 -->
    <div class="section">
      <div class="title">银行汇款（对公）</div>
      <div class="row" style="margin-top: 20px">
        <img class="bank-icon" :src="require('assets/image/bank1-icon.png')" />
        <div class="r-info">
          <p class="text1">公司名称：长春市智绘网络科技有限公司</p>
          <p class="text1">
            银行账号：<span style="color: #219fdb; font-weight: Bold"
              >52580188000071700</span
            >
          </p>
          <p class="text1">开户银行：中国光大银行长春净月开发区支行</p>
          <p class="text2">
            汇款成功后请将汇款凭证及充值ID发送至gogoing0708@126.com，等待客服审核处理。
          </p>
        </div>
      </div>
    </div>
    <!-- 微信二维码 -->
    <qrCodeModal
      :show.sync="qrCodeModalVisibility"
      :data="qrCodeData"
    ></qrCodeModal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { payRecharge } from "api/user.js";
import qrCodeModal from "components/back/qrCodeModal.vue";
import loading from "components/loading.vue";
const WEB_SCOKET_URL = process.env.VUE_APP_SCOKET;

export default {
  name: "recharge",
  components: {
    qrCodeModal,
    loading,
  },
  computed: {
    ...mapState(["freezeAmount", "balance", "token"]),
  },
  data() {
    return {
      form: {
        amount: "",
      },
      active: -1,
      orderNo: "",
      qrCodeModalVisibility: false,
      qrCodeData: {
        qrCodeUrl: "",
        type: 0,
      },
      orderLoading: false,
    };
  },
  beforeDestroy() {
    // 销毁定时器
    if (this.webSocket) {
      this.sendMessage("stop");
    }
    this.webSocketResetInterval && clearInterval(this.webSocketResetInterval);
    this.heartInterval && clearInterval(this.heartInterval);
  },
  methods: {
    ...mapMutations(["MUT_AMOUNT"]),
    ...mapActions(["ACT_AMOUNT_INFO"]),
    onAmountKeyUp() {
      this.form.amount = this.form.amount.replace(/[^\d^\.]+/g, "");
    },
    // 重置提交
    async req_payRecharge() {
      try {
        if (!this.form.amount) {
          this.$Message.warning("请输入充值金额！");
          return;
        }
        if (this.money < 1) {
          this.$Message.warning("充值最小金额1元！");
          return;
        }
        if (this.active === -1) {
          this.$Message.warning("请选择充值方式！");
          return;
        }
        let params = {
          amount: this.form.amount,
          source: 0,
          type: this.active,
        };
        this.orderLoading = true;
        const { code, data, result } = await payRecharge(params);
        this.orderLoading = false;
        if (code == 200 && result) {
          this.qrCodeData.type = params.type;
          this.qrCodeData.qrCodeUrl = data.url;
          this.orderNo = data.orderNo;
          this.qrCodeModalVisibility = true;
          this.startSocket();
        }
      } catch (error) {
        this.orderLoading = false;
        console.log(error);
      }
    },
    // 确认
    onConfirm() {
      this.req_payRecharge();
    },
    // webScoket发送消息
    sendMessage(txt) {
      this.webSocket.send(txt);
    },
    // webScoket异常重连
    resetConnect() {
      this.connectCount = this.connectCount || 0;
      if (!this.webSocketInterval) {
        this.webSocketResetInterval = setInterval(() => {
          this.connectCount += 1;
          if (this.connectCount <= 5) {
            this.startSocket();
            this.webSocketResetInterval &&
              clearInterval(this.webSocketResetInterval);
          }
        }, 1000);
      }
    },
    // 开启webScoket
    startSocket() {
      this.messageTotal = 0;
      this.webSocket = new WebSocket(
        `${WEB_SCOKET_URL}/cczhweb/webSocket/pay/${this.orderNo}/${this.token}`
      );
      // 接收消息事件
      this.webSocket.onmessage = (e) => {
        if (e.data === "open:suc") {
          this.sendMessage("start");
          this.heartInterval = setInterval(() => {
            if (this.messageTotal === 10) {
              this.sendMessage("heart");
              this.messageTotal = 0;
            }
            this.messageTotal += 1;
          }, 1000);
        }
        if (e.data.includes("msg:")) {
          const message = e.data.split("msg:")[1];
          this.messageTotal = 0;
          const info = JSON.parse(message);
          if (info != null) {
            if (info.result === "true") {
              this.clearSocket();
              this.qrCodeModalVisibility = false;
              this.$Message.success("充值成功！");
              this.form.amount = "";
              this.ACT_AMOUNT_INFO();
            }
          }
        }
        if (e.data.includes("rec:stop")) {
          this.webSocket.close();
        }
      };
      // 关闭事件
      // this.webSocket.onclose = () => {
      //   this.resetConnect();
      // };
      // 连接失败事件
      this.webSocket.onerror = () => {
        this.resetConnect();
      };
    },
    // 清空socket
    clearSocket() {
      if (this.webSocket) {
        this.sendMessage("stop");
        this.heartInterval && clearInterval(this.heartInterval);
        this.webSocketResetInterval &&
          clearInterval(this.webSocketResetInterval);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  position: relative;
  background-color: #fff;
  padding: 0 30px;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
.section {
  background-color: #fff;
  border-radius: 8px;
  margin: 50px;
  padding: 50px;
}
.col {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .label {
    color: #999999;
  }
}
.row {
  display: flex;
  align-items: center;
}
.cz-item {
  justify-content: center;
  width: 180px;
  height: 80px;
  background-color: #f0f3f6;
  border-radius: 8px;
  cursor: pointer;
  .text {
    font-size: 18px;
    font-weight: bold;
    margin-left: 20px;
  }
}
.actives {
  border: 1px solid #219fdb;
}
.cz-icon {
  width: 46px;
  height: 46px;
}
.wx-icon {
  width: 46px;
  height: 46px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #3992e9;
}
.bank-icon {
  width: 304px;
  height: 142px;
}
.r-info {
  margin-left: 60px;
  .text1 {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .text2 {
    font-size: 14px;
    font-weight: 400;
    color: #f9521f;
    line-height: 40px;
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
